import { useState, useEffect } from 'react';

export const useFixedNav = (distance, callback) => {
    const [showFixedNav, setShowFixedNav] = useState(false);

    const handleScroll = () => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        setShowFixedNav(scrollTop > distance);

        if (callback) {
            callback(scrollTop > distance);
        }
    };

    useEffect(
        () => {
            window.addEventListener('scroll', handleScroll);

            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        },
        [distance],
    );

    return showFixedNav;
};
